import { IFilter } from '../../types/filters';
import { ContainWordsContainer } from '../../containers/advancedFilters/ContainWordsContainer';

export const containWords: IFilter = {
  component: ContainWordsContainer,
};
